<template>
  <div>
    <div class="page-title mb-4 underline"><mdb-icon icon="highlighter" /> 사전 진단 평가 <span v-if="mode === 'VIEW'">결과보기</span></div>
    <test-common-process v-if="mode === 'CHECKTEST'" v-model="mode"/>
    <!-- 테스트 하기 -->
    <prediag-test v-if="mode === 'TEST'" @save-test="onSaveTest"/>
    <!-- 결과 보기 -->
    <prediag-test-question v-if="mode === 'VIEW'" :answers="answer.answers"/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import PrediagTest from '@/components/test/prediag/PrediagTest.vue';
import PrediagTestQuestion from '@/components/test/prediag/PrediagTestQuestion.vue';
import PreDiag from '@/models/test/PreDiag'
import TestCommonProcess from '@/components/test/TestCommonProcess.vue';

export default {
  name: 'StudentPrediagTest',
  components: { PrediagTest, PrediagTestQuestion, TestCommonProcess },
  props: [],
  data: () => ({
    mode: 'CHECKTEST'
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training'])
  },
  methods: {
    // 정답 저장
    async onSaveTest (answers) {
      this.mode++;
      this.answer = PreDiag.create(this.training._id, this.profile._id, answers)
      this.answer.mark()
      this.answer = await this.answer.save()
      this.mode = 'VIEW'
    },
    // 답지 추출
    async load () {
      this.answer = await PreDiag.get({ student: this.profile._id })
      if (this.answer) { // 성적이 있으면 보기 모드
        this.mode = 'VIEW'
      } else { // 성적이 없으면 테스트 모드
        this.mode = 'CHECKTEST'
      }
    }
  },
  watch: {
    async profile () {
      this.load()
    }
  },
  async created () {
    this.load()
  }
}
</script>
